import React from 'react';
import './about.css'; // Ensure to create this CSS file
import profilePhoto from '../../img/IMG_4965.JPG'; // Your profile photo
import CV from '../../img/Kabita cv.pdf'; // Link to your CV

const About = () => {
    return (
        <div className="about" id="aboutme">
            <div className="a-left">
                <img src={profilePhoto} alt="Profile" className="profile-photo" />
                <div className="cv-section">
                    <h2>Curriculum Vitae</h2>
                    <a href={CV} target="_blank" rel="noopener noreferrer">
                        <button className="button s-button">Download CV</button>
                    </a>
                    <div className="blur s-blurl" style={{ background: "#ABF1FF94" }}></div>
                </div>
            </div>
            <div className="a-right">
                <h1>About Me</h1>
                <p>
                    I am a passionate Web Designer and Developer with extensive experience in creating user-friendly and visually appealing web applications. 
                    My expertise lies in both development and design, allowing me to deliver comprehensive solutions that meet client needs.
                </p>
                <div className="skills">
                    <div className="skill-bar">
                        <span>Development</span>
                        <div className="skill-level" style={{ width: '80%' }} data-skill="90%"></div>
                    </div>
                    <div className="skill-bar">
                        <span>UI/UX Design</span>
                        <div className="skill-level" style={{ width: '60%' }} data-skill="75%"></div>
                    </div>
                    <div className="skill-bar">
                        <span>Photography</span>
                        <div className="skill-level" style={{ width: '55%' }} data-skill="60%"></div>
                    </div>
                </div>
                <div className="blur"></div>
            </div>
        </div>
    );
};

export default About;